import {TagScore} from '../state/global.types';
import {Dictionary} from 'vue-router/types/router';
import {v4} from 'uuid';
import {UserActivityCategoryEnum, CandidateItem} from '@mobi-components/global-solution';

export function mapAttributes(attributes: Dictionary<Dictionary<TagScore>>, x: CandidateItem) {
  attributes = attributes || {};
  const matchedTags = Object.keys(attributes[x.name] || {}).map((key: string) => {
    const score = attributes[x.name] || {};
    return {
      isBoolean: score[key].category === UserActivityCategoryEnum.GEOLOCATION || score[key].score <= 0,
      value: score[key].score <= 0 ? 0 : score[key].score,
      name: key,
      id: v4(),
    };
  });
  return matchedTags;
}
